export interface IMessageFile {
    _id: string;
    name: string;
    type: string;
}
